<mat-toolbar class="bg-white text-gray-800 border-b border-gray-200 px-6 py-2 flex items-center justify-between" *ngIf="isLogged">
  <!-- === MOBILE TOOLBAR === -->
  <ng-container *ngIf="isMobile; else desktopToolbar">
    <div class="flex items-center justify-between w-full">
      <!-- Botón menú -->
      <button mat-icon-button (click)="onToggleSidenav()">
        <mat-icon class="text-gray-700">menu</mat-icon>
      </button>

      <!-- Logo al centro -->
    <div class="flex justify-center" >
  <img src="assets/imgs/logo-la-soberania-2.png" alt="Logo" class="h-12 sm:h-16" />
      </div>

      <!-- Foto perfil -->
  <button mat-icon-button [matMenuTriggerFor]="accountMenu">
         <img src="assets/imgs/user.png" alt="Logo" class="w-10" />
      </button>
    </div>
  </ng-container>

  <!-- === DESKTOP TOOLBAR === -->
  <ng-template #desktopToolbar>
    <div class="flex items-center gap-4">
      <button mat-icon-button (click)="onToggleSidenav()">
        <mat-icon class="text-gray-700">menu</mat-icon>
      </button>
    </div>

    <div class="flex items-center gap-4">
    <button [matMenuTriggerFor]="accountMenu" class="p-2.5 hover:bg-gray-100 rounded text-gray-800">
        <div class="flex flex-row gap-2 h-[15px]">
      <div class="flex items-center text-[15px] text-gray-800">
            {{ nombreUsuario | titlecase }}
          </div>
          <div class="flex items-center">
            <img src="assets/svg/icon-dropdown-toolbar.svg" class="w-3 h-3" />
          </div>
        </div>
      </button>
    </div>
  </ng-template>
</mat-toolbar>

<!-- Menú desplegable del usuario -->
<mat-menu #accountMenu="matMenu" class="w-[250px] flex flex-row">
  <button (click)="irTiendas()" class="px-2.5 py-1 w-full hover:bg-gray-200 flex gap-2 items-center">
    <img src="assets/svg/home-menu.svg" class="w-[24px] h-[24px]" />
    <span class="text-[15px] text-gray-700">Inicio</span>
  </button>
  <button [routerLink]="'/account/profile/my-account'" class="px-2.5 py-1 w-full hover:bg-gray-200 flex gap-2 items-center">
    <img src="assets/svg/profile-icon.svg" class="w-[24px] h-[24px]" />
    <span class="text-[15px] text-gray-700">Perfil</span>
  </button>
  <button (click)="abrirConfiguraciones()" *ngIf="idRolUsuario == 1" class="px-2.5 py-1 w-full hover:bg-gray-200 flex gap-2 items-center">
    <img src="assets/svg/ajustes-menu.svg" class="w-[24px] h-[24px]" />
    <span class="text-[15px] text-gray-700">Ajustes</span>
  </button>
  <button (click)="abrirParametros()" *ngIf="idRolUsuario == 1" class="px-2.5 py-1 w-full hover:bg-gray-200 flex gap-2 items-center">
    <img src="assets/svg/parametros.svg" class="w-[24px] h-[24px]" />
    <span class="text-[15px] text-gray-700">Parámetros</span>
  </button>
  <button (click)="onLogout()" class="px-2.5 py-1 w-full hover:bg-gray-200 flex gap-2 items-center">
    <img src="assets/svg/logout-menu.svg" class="w-[24px] h-[24px]" />
    <span class="text-[15px] text-gray-700">Cerrar Sesión</span>
  </button>
</mat-menu>
